import CustomLink from '@common/components/CustomLink';
import Category from '@common/models/Category';
import SubCategoryDropdown from '@components/Layouts/SubCategoryDropdown';
import Arrow from '@images/LChevron.svg';
import OutsideClickHandler from '@lib/OutsideClickHandler';
import classnames from 'classnames';
import React, { useRef, useState } from 'react';
export interface CategoryDropdownProps {
  className?: string;
  category: Category;
  isFirstElement: boolean;
}

const CategoryDropdown: React.FunctionComponent<CategoryDropdownProps> = ({
  category = {},
  className,
  isFirstElement,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isSubDropdownOpen, setIsSubDropdownOpen] = useState(null);
  const [issubSubDropdownOpen, setIssubSubDropdownOpen] = useState(null);
  const [catTop, setCatTop] = useState(1);
  const [sideCategory, setSideCategory] = useState({});
  const divRef = useRef(null);

  return (
    <div
      onMouseLeave={() => {
        setIsDropdownOpen(false);
        setIsSubDropdownOpen(false);
        setIssubSubDropdownOpen(false);
        setSideCategory({});
      }}
      ref={divRef}
    >
      <OutsideClickHandler onOutsideClick={() => setIsDropdownOpen(false)}>
        <div
          className={classnames(
            'select-none flex items-center md:hidden h-48 cursor-pointer text-navbar-textColor text-16 pointer-events-none mr-36',
            className,
          )}
        >
          <CustomLink
            link={category?.storeLink}
            isExternal={category?.isExternalLink}
            font-customisation="section-heading"
            color-customisation="header-links"
            className="whitespace-no-wrap text-14 pointer-events-auto"
            category={category}
            id={'mobile-' + category?.name?.toLowerCase().split(' ').join('-') || ''}
          >
            {category?.id === 0 ? 'Shop' : category?.name}
          </CustomLink>
          {category?.childCategories?.length > 1 ? (
            <img
              src={Arrow}
              alt="Arrow"
              className="pointer-events-auto mr-24"
              onClick={() => {
                if (category?.childCategories?.length > 1) {
                  setIsDropdownOpen(!isDropdownOpen);
                }
              }}
            />
          ) : null}
        </div>
        <CustomLink
          onMouseEnter={() => {
            if (category?.childCategories?.length > 1) {
              setIsDropdownOpen(true);
            }
          }}
          link={
            category?.name === 'Shop All' && category?.childCategories?.length == 1
              ? '/shop?ordering=oos,final_price'
              : category?.storeLink
          }
          isExternal={category?.isExternalLink}
          className={classnames(
            'select-none hidden md:flex items-center relative h-60 md:py-18 cursor-pointer text-navbar-textColor text-16',
            className,
            {
              'md:pr-30': isFirstElement,
              'md:px-30': !isFirstElement,
            },
          )}
          category={category}
        >
          {category?.id === 1111 && category?.childCategories?.length < 1 ? null : (
            <span
              className="whitespace-no-wrap"
              font-customisation="section-heading"
              color-customisation="header-links"
              id={'header-' + category?.name?.toLowerCase().split(' ').join('-')}
            >
              {category?.id === 0 ? 'Shop' : category?.name}
            </span>
          )}
          {category?.childCategories?.length > 1 && category?.childCategories[0].id != 0 ? (
            <img className="ml-5" src={Arrow} alt="Arrow" />
          ) : null}
        </CustomLink>
        {isDropdownOpen ? (
          <SubCategoryDropdown
            category={category}
            isDropdownOpen={isDropdownOpen}
            isSubDropdownOpen={isSubDropdownOpen}
            issubSubDropdownOpen={issubSubDropdownOpen}
            catTop={catTop}
            setIsDropdownOpen={setIsDropdownOpen}
            setIsSubDropdownOpen={setIsSubDropdownOpen}
            setIssubSubDropdownOpen={setIssubSubDropdownOpen}
            setCatTop={setCatTop}
            sideCategory={sideCategory}
            setSideCategory={setSideCategory}
            layoutTopVal={150}
            divRefLeft={divRef.current?.getBoundingClientRect().left}
          />
        ) : null}
      </OutsideClickHandler>
    </div>
  );
};

export default CategoryDropdown;
